// OverviewCard.jsx
import React from "react";
import { Card } from "react-bootstrap";
import { motion } from "framer-motion";

const OverviewCard = ({ title, value, icon: IconComponent, color }) => {
  return (
    <motion.div whileHover={{ scale: 1.02 }} style={{ height: "100%" }}>
      <Card
        className="p-2"
        style={{
          borderRadius: "var(--radius-card)",
          background: "var(--color-bg-card)",
          border: "1px solid var(--color-border)",
          boxShadow: "var(--shadow-sm)",
          transition: "all 0.25s ease",
          height: "100%",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", height: "100%" }}>
          {/* ICON */}
          <div
            style={{
              background: `color-mix(in srgb, ${color} 18%, var(--color-bg-card))`,
              padding: 8,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              border: "1px solid var(--color-border)",
              marginBottom: 8,
            }}
          >
            <IconComponent size={18} color={color} />
          </div>

          {/* TITLE */}
          <div
            style={{
              fontSize: 13,
              color: "var(--color-text-light)",
              fontWeight: 600,
              lineHeight: 1.4,
              marginBottom: 6,
            }}
          >
            {title}
          </div>

          {/* VALUE */}
          <div
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: "var(--color-text)",
              lineHeight: 1.2,
            }}
          >
            {value}
          </div>
        </div>
      </Card>
    </motion.div>
  );
};

export default OverviewCard;
